import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { createOrgan } from '../../actions/organs-actions';
import { Link, useNavigate  } from 'react-router-dom';

function CreateOrgan(){
    const currentLink = "/organos-investigacion";
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(state => state.user.user);

    const [form, setForm] = useState({
        description: '',
        email: '',
    });

    const handleInputChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
    }

    const handleOnSubmit = (event) => {
        event.preventDefault();
        const isEmpty = Object.values(form).some(x => x === null || x === '');
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar todos los datos para continuar",
            });
            return;
        } else {
            dispatch( createOrgan( form,createFunction, user.token ) );
        }
    }

    const createFunction = (data) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            navigate(currentLink)
            //console.log(data);
            Swal.fire({
                title:"¡Éxito!",
                confirmButtonColor:"#76b4ff",
                text: "Órgano de investigación creado con éxito"
            });
        }
    }

    useEffect(() => {
        //console.log(form)
    }, [form]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <div className="w-100 mt-5">
                    <Link to={currentLink} className="back-button">&#60; Volver</Link>
                </div>
                <h1 className="my-5">Nuevo órgano de investigación</h1>
                <form onSubmit={handleOnSubmit}>
                    <div className="d-flex w-100 flex-wrap">
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="description">Nombre</label>
                            <input id="description" name="description" autoComplete="off" maxLength={100} className="input-field" type="text" onChange={handleInputChange} value={form.description}></input>
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="email">Email</label>
                            <input id="email" name="email" autoComplete="off" maxLength={120} className="input-field" type="email" onChange={handleInputChange} value={form.email}></input>
                        </div>
                        <div className="w-100 d-flex d-flex justify-content-center my-4">
                            <button className="primary-button save-button" type="submit">Guardar &#43;</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CreateOrgan;
  